export * from "./debug.js";
export const SPAN_SIZE = 8;
export const SECTION_SIZE = 32;
export const BRANCHES = 128;
export const CHUNK_SIZE = SECTION_SIZE * BRANCHES;
export const ADDRESS_HEX_LENGTH = 64;
export const PSS_TARGET_HEX_LENGTH_MAX = 6;
export const PUBKEY_HEX_LENGTH = 66;
export const BATCH_ID_HEX_LENGTH = 64;
export const REFERENCE_HEX_LENGTH = 64;
export const ENCRYPTED_REFERENCE_HEX_LENGTH = 128;
export const REFERENCE_BYTES_LENGTH = 32;
export const ENCRYPTED_REFERENCE_BYTES_LENGTH = 64;
/**
 * Minimal depth that can be used for creation of postage batch
 */

export const STAMPS_DEPTH_MIN = 17;
/**
 * Maximal depth that can be used for creation of postage batch
 */

export const STAMPS_DEPTH_MAX = 255;
export const TAGS_LIMIT_MIN = 1;
export const TAGS_LIMIT_MAX = 1000;
/*********************************************************
 * Writers and Readers interfaces
 */

export const TOPIC_BYTES_LENGTH = 32;
export const TOPIC_HEX_LENGTH = 64;
/*********************************************************
 * Ethereum compatible signing interfaces and definitions
 */

export const SIGNATURE_HEX_LENGTH = 130;
export const SIGNATURE_BYTES_LENGTH = 65;